import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {RoutePartsService} from './shared/services/route-parts.service';
import {filter} from 'rxjs/operators';
import {UILibIconService} from './shared/services/ui-lib-icon.service';
import {PrimeNGConfig} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { PosUtilityService } from './views/pos/pos-services/pos-utility.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
    appTitle = 'Kiami';
    pageTitle = '';
    formControl = new FormControl();
    controlOne = new FormControl();

    constructor(
        public title: Title,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private routePartsService: RoutePartsService,
        private iconService: UILibIconService,
        public posUtility: PosUtilityService,
        private config: PrimeNGConfig, private translateService: TranslateService
    ) {
        iconService.init();
    }

    ngOnInit() {
        this.translateService.addLangs(['pt']);
        this.translateService.setDefaultLang('pt');
        this.translate('pt');
    }

    translate(lang: string) {
        this.translateService.use(lang);
        this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
    }

    ngAfterViewInit() {
    }

    changePageTitle() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange) => {
            const routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
            if (!routeParts.length) {
                return this.title.setTitle(this.appTitle);
            }
            // Extract title from parts;
            this.pageTitle = routeParts
                .reverse()
                .map((part) => part.title)
                .reduce((partA, partI) => {
                    return `${partA} > ${partI}`;
                });
            this.pageTitle += ` | ${this.appTitle}`;
            this.title.setTitle(this.pageTitle);
        });
    }
}
